module.exports = __webpack_public_path__ + "static/media/DSCF3635.5ad449ff.jpg";